export function stateProviderConfig($urlRouterProvider) {

	"ngInject";

	$urlRouterProvider.when("/", "/app/deployments/");

}


// WEBPACK FOOTER //
// ./sources/config/stateProvider.config.js